const SearchIcon = () => {
  return (
    <svg className="search-icon" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.23234 7.46468C6.01751 7.46468 7.46468 6.01751 7.46468 4.23234C7.46468 2.44717 6.01751 1 4.23234 1C2.44717 1 1 2.44717 1 4.23234C1 6.01751 2.44717 7.46468 4.23234 7.46468Z" stroke="#A4A0A0" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9.00018 8.99993L6.81836 6.81812" stroke="#A4A0A0" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default SearchIcon